import React from 'react';
import PersonalSectionContainer from './PersonalSectionContainer';
import ExtendedFooterSection from './ExtendedFooterSection';
import ProductDetailEasyFooter from '../../product/detail/easy/ProductDetailEasyFooter';
import { Footer } from './Footer';

interface Props {
  showStickyFooter?: boolean;
}

export const FooterContainer = ({
  showStickyFooter = false,
}: Props) => {
  if (showStickyFooter) {
    return (
      <>
        <footer>
          <PersonalSectionContainer />
          <ExtendedFooterSection />
        </footer>
        <ProductDetailEasyFooter />
      </>
    );
  }

  return (
    <footer>
      <PersonalSectionContainer />
      <ExtendedFooterSection />
      <Footer />
    </footer>
  );
};
